import { GridDetailRowProps, GridItemChangeEvent } from '@progress/kendo-react-grid';
import { FC } from 'react';
import {
  invoiceDetailsGLCodeSubColumns,
  useInvoiceDetailsGLCodesColumns,
} from 'src/assets/static/invoice_details/GlCodes';
import GridWrapper from 'src/components/GridWrapper';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from './InvoiceDetailsContext';
import InvoiceGlCodesToolbar from './InvoiceGlCodesToolbar';

const DetailComponent = (props: GridDetailRowProps) => (
  <GridWrapper
    dataSource={props.dataItem.items}
    columns={invoiceDetailsGLCodeSubColumns}
    DataItemKey="field"
    resizable={true}
  />
);

interface GLDistributionTableProps {
  onItemChange?: (e: GridItemChangeEvent) => void;
  dataSource: any[];
  DataItemKey?: string;
}

const GLDistributionTable: FC<GLDistributionTableProps> = ({
  dataSource,
  onItemChange,
  DataItemKey = 'field',
}) => {
  const invoiceDetailsGLCodesColumns = useInvoiceDetailsGLCodesColumns();
  const showScans = useContextSelector(InvoiceContext, (value) => value.showScans);

  return (
    <GridWrapper
      key={`${showScans}-${invoiceDetailsGLCodesColumns.length}`}
      id="invoiceGLSummaryGrid"
      columns={invoiceDetailsGLCodesColumns}
      dataSource={dataSource}
      DataItemKey={DataItemKey}
      onItemChange={onItemChange}
      detail={DetailComponent}
      gridToolbarChildren={<InvoiceGlCodesToolbar />}
      resizable
      className={'max-h-[300px] auto-scrollbar'}
      hideScrollBar
      isCustomExpandableRow
    />
  );
};

export default GLDistributionTable;
